import { MessageSquare, Target, FileText, Rocket } from "lucide-react";

const PartnershipProcess = () => {
  const steps = [
    {
      icon: MessageSquare,
      step: "1",
      title: "Initial Discussion",
      description: "20-30 min conversation to understand CSR objectives"
    },
    {
      icon: Target,
      step: "2",
      title: "Scope Alignment",
      description: "Match program models to your focus areas"
    },
    {
      icon: FileText,
      step: "3",
      title: "Budget & Documentation",
      description: "CSR-compliant proposal and governance docs"
    },
    {
      icon: Rocket,
      step: "4",
      title: "Deployment & Reporting",
      description: "Implementation with structured outcome tracking"
    }
  ];

  return (
    <section className="py-12 md:py-16 bg-white" data-testid="partnership-process-section">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="max-w-4xl mx-auto">
          
          {/* Section Header */}
          <div className="text-center mb-10">
            <h2 className="font-display text-2xl md:text-3xl font-bold text-[#4A4A4A] mb-3">
              How the Partnership Process Works
            </h2>
            <p className="text-[#6B7280] text-sm">
              A structured 4-step engagement for CSR teams
            </p>
          </div>

          {/* Steps Strip */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {steps.map((item, index) => (
              <div 
                key={index}
                className="relative text-center p-5 bg-[#F8F9F7] rounded-lg border border-[#E5E7EB]"
                data-testid={`process-step-${index}`}
              >
                {/* Step Number Badge */}
                <div className="absolute -top-3 left-1/2 -translate-x-1/2 w-6 h-6 rounded-full bg-[#1F7A5A] text-white text-xs font-bold flex items-center justify-center">
                  {item.step}
                </div>
                
                {/* Icon */}
                <div className="w-10 h-10 mx-auto rounded-lg bg-[#1F7A5A]/10 flex items-center justify-center mb-3 mt-2">
                  <item.icon className="w-5 h-5 text-[#1F7A5A]" />
                </div>
                
                {/* Title */}
                <h3 className="font-semibold text-[#4A4A4A] text-sm mb-1">
                  {item.title}
                </h3>
                
                {/* Description */}
                <p className="text-[#6B7280] text-xs leading-relaxed">
                  {item.description}
                </p>

                {/* Connector Arrow (not on last item) */}
                {index < steps.length - 1 && (
                  <div className="hidden md:block absolute top-1/2 -right-2 w-4 h-4 text-[#E5E7EB]">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M9 18l6-6-6-6" />
                    </svg>
                  </div>
                )}
              </div>
            ))}
          </div>

        </div>
      </div>
    </section>
  );
};

export default PartnershipProcess;
